<template>
  <div class="buy">
    <div class="goodSearch">
      <van-search
        v-model="couponCode"
        placeholder="请输入商品条码"
        @search="searchCouponByCode"
        show-action
      >
        <template #action>
          <van-button
            type="info"
            icon="search"
            size="small"
            @click="searchCouponByCode"
            >搜索</van-button
          >
          <van-button
            icon="scan"
            size="small"
            type="info"
            style="margin-left:2px"
            @click="doScan"
            >扫描</van-button
          >
        </template>
      </van-search>
      <div class="couponListDiv">
        <div
          v-for="(item, idx) in coupons"
          v-bind:key="idx"
          @click="changCouponChecked(idx)"
        >
          <van-coupon :chosen="item.checked" :coupon="item"> </van-coupon>
        </div>
      </div>
    </div>
    <van-submit-bar
      :price="totalPrice"
      button-text="批量激活"
      @submit="onSubmit"
    >
      <van-checkbox @click="changAllChecked" v-model="checkedAll"
        >全选</van-checkbox
      >
    </van-submit-bar>
  </div>
</template>

<script>
import "../../assets/css/buy.less";
import { queryPost, setWxConfig } from "@/api/common";
import wx from "weixin-js-sdk";

export default {
  name: "BatchActivate",
  data() {
    return {
      success: true,
      showPopup: false,
      showGood: false,
      couponCode: "",
      buyNumber: 1,
      cartNum: "",
      goodInfo: {},
      shopInfo: {},
      cardInfo: {},
      coupons: [],
      chosenCoupon: -1,
      disabledCoupons: []

      // checkedAll: false
    };
  },
  computed: {
    totalPrice: function() {
      // `this` 指向 vm 实例
      let total = 0.0;
      for (let i = 0; i < this.coupons.length; i++) {
        const coupon = this.coupons[i];
        if (coupon.checked) {
          total += coupon.couponPrice - coupon.prepayAmount;
        }
      }
      return total * 100;
    },
    checkedAll: function() {
      let checked = true;
      for (let i = 0; i < this.coupons.length; i++) {
        const coupon = this.coupons[i];
        if (!coupon.checked) {
          checked = false;
          break;
        }
      }
      return checked;
    }
  },
  created() {
    this.loadComments();
  },
  methods: {
    loadComments() {
      // debugger
      let s = sessionStorage.getItem("shopInfo");
      let c = sessionStorage.getItem("cardInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
      this.cardInfo = c ? JSON.parse(c) : "";

      // wx.ready;
      wx.error(function(res) {
        // config 信息验证失败会执行error函数,如签名过期导致验证失败,具体错误信息可以打开config的debug模式查看,也可以在返回的res参数中查看,对于SPA可以在这里更新签名
        setWxConfig(window.location.href);
        console.log(res.errMsg);
      });
    },

    doScan() {
      let _this = this;
      /* 处理失败验证 */

      wx.ready(function() {
        wx.checkJsApi({
          jsApiList: ["scanQRCode"],
          success: function(res) {
            // 以键值对的形式返回，可用true，不可用false。如：{"checkResult":{"scanQRCode":true},"errMsg":"checkJsApi:ok"}
            if (res.checkResult.scanQRCode === true) {
              wx.scanQRCode({
                // 微信扫一扫接口
                desc: "scanQRCode desc",
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: function(res) {
                  const getCode = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                  _this.couponCode = getCode.split(",")[1];
                  _this.searchCouponByCode();
                  // _this.$toast.fail(getCode);
                }
              });
            } else {
              alert("抱歉，当前客户端版本不支持扫一扫");
            }
          },
          fail: function(res) {
            // 检测getNetworkType该功能失败时处理
            alert("fail" + res);
          }
        });
      });
    },

    searchCouponByCode() {
      let _this = this;
      if (!this.couponCode) {
        alert("请输入提货卡编码或扫描提货卡条形码!");
        return;
      }
      let url = "/order/couponBusiness/findByCouponCode";
      let data = {
        couponCode: this.couponCode
      };
      queryPost(url, data)
        .then(resp => {
          let _data = resp.data;
          if (_data.code == "0000") {
            let temp = _data.data.results;
            _this.goodInfo = temp;
            if (!temp) {
              _this.$toast.fail("卡不存在!");
              return;
            }
            if (temp.couponStatus != 1) {
              if (temp.couponStatus == 0) {
                _this.$toast.fail("卡券不存在,或未初始化!");
              } else {
                _this.$toast.fail("卡券已激活过,请勿重复操作!");
              }
              return;
            }
            const shopId = sessionStorage.getItem("shopInfo")
              ? JSON.parse(sessionStorage.getItem("shopInfo")).shopCode
              : "";
            if (temp.activationStore !== shopId) {
              _this.$toast.fail("该卡券已派发给其它店铺!");
              return;
            }
            let coupon = {
              id: temp.id,
              available: 1,
              condition: "已预付金额:" + temp.prepayAmount,
              name: "卡券编码:" + temp.couponCode,
              startAt: new Date(temp.startTime),
              endAt: new Date(temp.endTime),
              valueDesc: temp.couponPrice + "",
              description:
                temp.startTime.substr(0, 10) +
                "至" +
                temp.endTime.substr(0, 10),
              customValidPeriod: "指定商品:" + temp.designatedGoods,
              unitDesc: "元",
              checked: true,
              couponPrice: temp.couponPrice,
              prepayAmount: temp.prepayAmount,
              couponCode: temp.couponCode,
              designatedGoods: temp.designatedGoods,
              startTime: temp.startTime.substr(0, 10),
              endTime: temp.endTime.substr(0, 10)
            };
            if (!_this.hasCoupon(coupon.id)) {
              this.coupons.unshift(coupon);
            } else {
              _this.$toast.fail("已添加!");
            }
            this.coupon = coupon;
            _this.showGood = true;
          } else {
            _this.$toast.fail(_data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    onChange: function(e) {
      this.chosenCoupon = e;
      this.coupons[e].checked = true;
    },
    changCouponChecked: function(index) {
      this.coupons[index].checked = !this.coupons[index].checked;
    },
    //是否添加过
    hasCoupon: function(id) {
      for (var i = 0; i < this.coupons.length; i++) {
        if (id === this.coupons[i].id) {
          return true;
        }
      }
      return false;
    },
    //加入购物车
    toSettle() {
      this.$router.push("settle");
    },
    onSubmit() {
      let couponChosen = [];
      for (let i = 0; i < this.coupons.length; i++) {
        const coupon = this.coupons[i];
        if (coupon.checked) {
          couponChosen.push(coupon);
        }
      }
      let params = {
        coupons: couponChosen
      };
      //前往激活提货卡
      this.$router.push({ path: "/activateCoupon", query: params });
    },
    changAllChecked: function(e) {
      console.log(e);
      let change = true;
      if (this.checkedAll) {
        change = false;
      }
      for (let i = 0; i < this.coupons.length; i++) {
        this.coupons[i].checked = change;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.couponListDiv {
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 85vh;
}
::v-deep .van-search__action{
  line-height: unset;
}
</style>
